import React, { useState, useEffect } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import _ from 'lodash';

import Pagination from 'components/Libs/Pagination';
import TextField from 'material-ui/TextField';
import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';

const styles = {
    textField: {
        hintStyle: { fontSize: 12 },
        style: { fontSize: 12, width: 'unset' },
    },
    table: {
        // Base styles for all columns
        baseColumnStyle: {
            padding: '8px 10px',
            fontSize: '13px',
            borderBottom: '1px solid rgba(0, 188, 212, 0.2)',
            height: 'auto',
            overflow: 'visible',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            hyphens: 'auto',
            lineHeight: '1.4',
        },
        
        row: {
            style: {
                height: 'auto',
                borderBottom: '1px solid rgba(0, 188, 212, 0.1)',
                transition: 'background-color 0.2s ease',
                ':hover': {
                    backgroundColor: 'rgba(0, 188, 212, 0.05)',
                },
            },
        },
        
        col: {
            style: {
                padding: '8px 10px',
                fontSize: '13px',
                fontWeight: '500',
                borderBottom: '1px solid rgba(0, 188, 212, 0.2)',
                height: 'auto',
                overflow: 'visible',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
                hyphens: 'auto',
                lineHeight: '1.4',
            },
        },
        
        sortLayoutByn: {
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        
        smallCol: {
            style: {
                position: 'relative',
                cursor: 'pointer',
                padding: '8px 10px',
                fontWeight: '500',
                width: '55px',
                fontSize: '13px',
                textAlign: 'center',
                borderBottom: '1px solid rgba(0, 188, 212, 0.2)',
                height: 'auto',
                overflow: 'visible',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
                hyphens: 'auto',
                lineHeight: '1.4',
            },
        },
        
        firstCol: {
            style: {
                padding: '8px 10px',
                fontSize: '13px',
                fontWeight: '500',
                borderBottom: '1px solid rgba(0, 188, 212, 0.2)',
                height: 'auto',
                overflow: 'visible',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
                hyphens: 'auto',
                lineHeight: '1.4',
            },
        },
        
        fullColumn: {
            style: {
                width: '300px',
                padding: '8px 10px',
                fontSize: '13px',
                borderBottom: '1px solid rgba(0, 188, 212, 0.2)',
                height: 'auto',
                overflow: 'visible',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
                hyphens: 'auto',
                lineHeight: '1.4',
                backgroundColor: 'rgba(0, 188, 212, 0.03)',
                // fontFamily: 'Roboto, sans-serif',
            },
        },
        
        headerStyle: {
            style: {
                fontSize: '14px',
                fontWeight: 'bold',
                color: 'rgb(0, 188, 212)',
                borderBottom: '2px solid rgb(0, 188, 212)',
                textTransform: 'uppercase',
                padding: '10px',
                backgroundColor: 'rgba(0, 188, 212, 0.05)',
            },
        },
    },
};

const AnnotationList = (props) => {
    const [directionById, setDirectionById] = useState(true);
    const [rowsPerPage] = useState([10, 20, 30]);
    const [rows, setRows] = useState([]);
    const [numberOfRows, setNumberOfRows] = useState(10);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [annotations, setAnnotations] = useState(props.annotations);
    const [searchText, setSearchText] = useState('');

    const sortById = (items) => {
        const newItems = [...items];

        newItems.sort((a, b) => {
            if (directionById) {
                if (a.id > b.id) {
                    return 1;
                }

                if (a.id < b.id) {
                    return -1;
                }

                return 1;
            } 
            if (a.id < b.id) {
                return 1;
            }

            if (a.id > b.id) {
                return -1;
            }

            return 1;
        });

        return newItems;
    };

    const changeSortById = () => {
        setDirectionById(!directionById);
        const { annotations: filteredAnnotations } = filterAnnotations(searchText, props.annotations);
        
        setPage(1);
        const sortedAnnotations = sortById(filteredAnnotations);
        setAnnotations(sortedAnnotations);
        setTotal(filteredAnnotations.length);
        
        setTimeout(() => {
            handleUpdateRow({
                page: 1,
                numberOfRows,
                annotations: sortedAnnotations,
            });
        }, 0);
    };

    const filterAnnotations = (text = searchText, annotationsData = props.annotations) => {
        const searchLower = text.toLowerCase();

        const filteredAnnotations = annotationsData.filter((annotation) => {
            if (_.has(annotation, 'features.rule')
                && annotation.features.rule.toLowerCase().includes(searchLower)) {
                return true;
            }

            if (_.has(annotation, 'features.majorType')
                && annotation.features.majorType.toLowerCase().includes(searchLower)) {
                return true;
            }

            if (_.has(annotation, 'features.string')
                && annotation.features.string.toLowerCase().includes(searchLower)) {
                return true;
            }

            if (_.has(annotation, 'type')
                && annotation.type.toLowerCase().includes(searchLower)) {
                return true;
            }

            if (annotation.id) {
                const id = annotation.id + '';
                if (id.includes(searchLower)) {
                    return true;
                }
            }

            return false;
        });

        return {
            searchText: text,
            annotations: filteredAnnotations,
        };
    };

    const handleSearch = (e, value) => {
        const { annotations: filteredAnnotations } = filterAnnotations(value);

        setPage(1);
        setAnnotations(filteredAnnotations);
        setSearchText(value);
        
        setTimeout(() => {
            handleUpdateRow({
                page: 1,
                numberOfRows,
                annotations: filteredAnnotations,
            });
        }, 0);
    };

    const changeRowsByPagination = (state) => {
        const elementsOnPage = state.numberOfRows;
        const offset = state.page - 1;
        const from = offset * elementsOnPage;
        const to = (offset * elementsOnPage) + elementsOnPage;

        return (state.annotations || annotations).slice(from, to);
    };

    const handleUpdateRow = (newState) => {
        const newRows = changeRowsByPagination(newState);
        setRows(newRows);
        
        if (newState.page !== page) {
            setPage(newState.page);
        }
        
        if (newState.numberOfRows !== numberOfRows) {
            setNumberOfRows(newState.numberOfRows);
        }
    };

    useEffect(() => {
        const { annotations: filteredAnnotations } = filterAnnotations(searchText, props.annotations);
        const sortedAnnotations = sortById(filteredAnnotations);
        
        setPage(1);
        setAnnotations(sortedAnnotations);
        setTotal(props.annotations.length);
        
        handleUpdateRow({
            page: 1,
            numberOfRows,
            annotations: sortedAnnotations,
        });
    }, [props.annotations]);

    useEffect(() => {
        handleUpdateRow({
            page,
            numberOfRows,
            annotations,
        });
    }, []);

    const { annotationsHeaders } = props;

    return (
        <div className='annotations-list-b'>
            <div
                className='navigation'
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    borderBottom: '2px solid rgba(0, 188, 212, 0.3)',
                    backgroundColor: 'rgba(0, 188, 212, 0.05)',
                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
                    borderTopLeftRadius: '2px',
                    borderTopRightRadius: '2px',
                }}
            >
                <div
                    className='navigation-search'
                    style={{
                        marginRight: '20px',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <span style={{
                        fontSize: '13px',
                        fontWeight: 'bold',
                        color: 'rgb(0, 188, 212)',
                        marginRight: '8px',
                    }}
                    >
                            Search:
                    </span>
                    <TextField
                        hintText='Enter search term...'
                        hintStyle={{
                            ...styles.textField.hintStyle,
                            color: 'rgba(0, 0, 0, 0.3)',
                        }}
                        style={{
                            ...styles.textField.style,
                            marginBottom: 0,
                        }}
                        inputStyle={{
                            padding: '2px 5px',
                            border: '1px solid rgba(0, 188, 212, 0.3)',
                            borderRadius: '3px',
                            backgroundColor: 'white',
                        }}
                        underlineShow={false}
                        onChange={handleSearch}
                        value={searchText || ''}
                    />
                </div>

                <div
                    className='navigation-arrows'
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginRight: '20px',
                        padding: '0 10px',
                        borderLeft: '1px solid rgba(0, 188, 212, 0.2)',
                        borderRight: '1px solid rgba(0, 188, 212, 0.2)',
                    }}
                >
                    <Pagination
                        total={annotations.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        numberOfRows={numberOfRows}
                        updateRows={handleUpdateRow}
                    />
                </div>

                <div
                    className='navigation-info'
                    style={{
                        fontSize: '12px',
                        color: 'rgba(0, 0, 0, 0.7)',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <div style={{ marginBottom: '3px' }}>
                        <span style={{ fontWeight: 'bold', color: 'rgb(0, 188, 212)' }}>Annotations:</span> 
                        <span style={{ marginLeft: '5px' }}>{annotations.length}</span>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <div style={{ marginRight: '10px' }}>
                            <span style={{ fontWeight: 'bold', color: 'rgb(0, 188, 212)' }}>Time:</span> 
                            <span style={{ marginLeft: '5px' }}>{annotationsHeaders['x-parse-time']} ms</span>
                        </div>
                        <div>
                            <span style={{ fontWeight: 'bold', color: 'rgb(0, 188, 212)' }}>Server:</span> 
                            <span style={{ marginLeft: '5px' }}>{annotationsHeaders['x-server-name']}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className='annotations-table' style={{ overflow: 'auto' }}>
                <Table 
                    selectable={false} 
                    fixedHeader
                    wrapperStyle={{ height: '100%' }}
                    bodyStyle={{ height: 'calc(100% - 42px)' }}
                >
                    <TableHeader
                        displaySelectAll={false}
                        adjustForCheckbox={false}
                    >
                        <TableRow style={styles.table.row.style}>
                            <TableHeaderColumn style={{ ...styles.table.col.style, ...styles.table.headerStyle.style }}>Value</TableHeaderColumn>
                            <TableHeaderColumn style={{ ...styles.table.col.style, ...styles.table.headerStyle.style }}>Rule</TableHeaderColumn>
                            <TableHeaderColumn style={{ ...styles.table.col.style, ...styles.table.headerStyle.style }}>Type</TableHeaderColumn>
                            <TableHeaderColumn style={{ ...styles.table.col.style, ...styles.table.headerStyle.style }}>MajorType</TableHeaderColumn>
                            <TableHeaderColumn style={{ ...styles.table.fullColumn.style, ...styles.table.headerStyle.style }}>Features</TableHeaderColumn>
                            <TableHeaderColumn style={{ ...styles.table.smallCol.style, ...styles.table.headerStyle.style }}>
                                <div style={styles.table.sortLayoutByn} onClick={changeSortById}>
                                        id {directionById ? '▲' : '▼'}
                                </div>
                            </TableHeaderColumn>
                        </TableRow>
                    </TableHeader>

                    <TableBody displayRowCheckbox={false} style={{ height: 'calc(100% - 42px)' }}>
                        {
                            rows.map((annotation, i) => (
                                <TableRow 
                                    style={{
                                        ...styles.table.row.style,
                                        backgroundColor: i % 2 === 0 ? 'rgba(0, 188, 212, 0.02)' : 'transparent',
                                    }} 
                                    key={i}
                                    hoverable
                                >
                                    <TableRowColumn style={{
                                        ...styles.table.firstCol.style,
                                        color: 'rgba(0, 0, 0, 0.8)',
                                        fontWeight: 500,
                                    }}
                                    >
                                        {annotation.features.string}
                                    </TableRowColumn>
                                    <TableRowColumn style={styles.table.col.style}>
                                        {annotation.features.rule}
                                    </TableRowColumn>
                                    <TableRowColumn style={styles.table.col.style}>
                                        {annotation.type}
                                    </TableRowColumn>
                                    <TableRowColumn style={styles.table.col.style}>
                                        {annotation.features.majorType}
                                    </TableRowColumn>
                                    <TableRowColumn style={{
                                        ...styles.table.fullColumn.style,
                                        backgroundColor: 'rgba(0, 188, 212, 0.03)',
                                        borderLeft: '1px solid rgba(0, 188, 212, 0.1)',
                                        borderRight: '1px solid rgba(0, 188, 212, 0.1)',
                                    }}
                                    >
                                        <pre style={{
                                            margin: 0,
                                            padding: 0,
                                            fontSize: '12px',
                                            fontFamily: 'monospace',
                                            whiteSpace: 'pre-wrap',
                                            wordBreak: 'break-word',
                                        }}
                                        >
                                            {annotation.features ? JSON.stringify(annotation.features, null, 2) : ''}
                                        </pre>
                                    </TableRowColumn>
                                    <TableRowColumn style={{
                                        ...styles.table.smallCol.style,
                                        textAlign: 'center',
                                        fontWeight: 'bold',
                                        color: 'rgba(0, 188, 212, 0.8)',
                                    }}
                                    >
                                        {annotation.id}
                                    </TableRowColumn>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
            </div>
        </div>
    );
};

export default connect(
    ({ annotations: { items: annotations, headers: annotationsHeaders } }) => ({
        annotations,
        annotationsHeaders,
    }),
    dispatch => bindActionCreators({

    }, dispatch),
)(AnnotationList);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/List/Annotation.jsx